import Vue from 'vue'
import $store from '@/code-lab/store'
const b$ = Vue.prototype.b$;
const closeQuick = () => {
    b$.close("quick");
    $store.commit("quickConnection/connectDevices", []);
    $store.commit("quickConnection/setRobotInfo", []);
    $store.commit('handleConnectGolbalState', null);
}
const closeRms = () => {
    b$.close("rms");
    $store.commit("rmsConnection/allDevice", []);
    $store.commit("rmsConnection/HANDLERMSDEVICES", []);
    $store.commit("rmsConnection/HANDLECONNECTDEVICES", []);
    $store.commit("rmsConnection/setRmsGroups", []);
    $store.commit('handleConnectGolbalState', null);
}

const closeWhite = () => {
    b$.close("white");
    $store.commit("rmsConnection/setRmsGroups", []);
    $store.commit('handleConnectGolbalState', null);
}
export {
    closeQuick,
    closeRms,
    closeWhite
}